import React from 'react'

import { FiftyFiftyProps } from 'lib/components/FiftyFifty/FiftyFifty'
import { NarrativeHeroProps } from 'lib/components/NarrativeHero/NarrativeHero'

export interface WhatCanIShipPageContent {
  hero: NarrativeHeroProps
  fiftyFiftiesMeta: FiftyFiftyProps[]
}

export interface NarrativeStep {
  body: string | React.ReactNode
}

const BACKGROUND_IMAGE = '/images/shipsticks/what-can-i-ship-hero.jpg'

const hero: NarrativeHeroProps = {
  header: 'What you can ship with ShipSticks',
  subHeader: 'Ship your golf clubs, luggage, and more.',
  backgroundImage: BACKGROUND_IMAGE,
}

const fiftyFiftiesMeta: FiftyFiftyProps[] = [
  {
    backgroundColor: 'grey',
    body: `
            Ship your full set, junior clubs, or even a Sunday bag - just pack them up in a soft
            travel bag, hard case, or box. We'll handle the rest.
    `,
    showEyebrow: false,
    header: 'Ship golf clubs',
    image: {
      src: '/images/shipsticks/what-can-i-ship-1.jpg',
    },
    layout: 'image-right',
    button: {
      text: 'How to pack',
      link: {
        href: '/pack',
      },
    },
  },
  {
    backgroundColor: 'grey',
    body: `
            Travel completely bag-free by shipping your luggage ahead, too.
            Ship your suitcase, duffel, or roller bag and skip the airport
            stress.
    `,
    showEyebrow: false,
    header: 'Ship luggage',
    image: {
      src: '/images/shipsticks/what-can-i-ship-2.jpg',
    },
    layout: 'image-left',
  },
  {
    backgroundColor: 'grey',
    body: `
            Planning a buddy trip, corporate outing, or tournament? Easily
            send multiple bags to or from a single destination without the
            hassle.
    `,
    showEyebrow: false,
    header: 'Group & event shipments',
    image: {
      src: '/images/shipsticks/what-can-i-ship-3.jpg',
    },
    layout: 'image-right',
    button: {
      text: 'Learn more',
      link: {
        href: 'https://www.shipsticks.com/form/group-shipping-request',
      },
    },
  },
  {
    backgroundColor: 'grey',
    body: `
            Traveling with more than just the basics, like an extra-large
            golf bag or a push cart? No problem. Our customer support team
            is happy to provide a custom quote. Contact us to get started.
    `,
    showEyebrow: false,
    header: 'Ship specialty items',
    image: {
      src: '/images/shipsticks/what-can-i-ship-4.jpg',
    },
    layout: 'image-left',
    button: {
      text: 'Contact us',
      link: {
        href: '/contact',
      },
    },
  },
]

const content: WhatCanIShipPageContent = {
  hero,
  fiftyFiftiesMeta,
}

export default content
